import styled from 'styled-components';

const GroupExecutionButtons = styled.div`
  button ~ button {
    margin-left: 0.5rem;
  }
`;

export { GroupExecutionButtons };
